function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.5 7C8.84375 7 8.24219 7.25781 7.79688 7.67187L4.98438 6.26562C4.99219 6.17969 5 6.08594 5 6C5 5.91406 4.99219 5.82031 4.98438 5.73437L7.79688 4.32812C8.24219 4.74219 8.84375 5 9.5 5C10.8828 5 12 3.88281 12 2.5C12 1.11719 10.8828 0 9.5 0C8.11719 0 7 1.11719 7 2.5C7 2.58594 7.00781 2.67969 7.01563 2.76562L4.20313 4.17187C3.75781 3.75781 3.15625 3.5 2.5 3.5C1.11719 3.5 0 4.61719 0 6C0 7.38281 1.11719 8.5 2.5 8.5C3.15625 8.5 3.75781 8.24219 4.20313 7.82812L7.01563 9.23437C7.00781 9.32031 7 9.41406 7 9.5C7 10.8828 8.11719 12 9.5 12C10.8828 12 12 10.8828 12 9.5C12 8.11719 10.8828 7 9.5 7Z",
  fill: "#B3B3B3"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white"
})));

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Share.c5d0fc39.svg";
export { ForwardRef as ReactComponent };